import attRequest from "@/pages/attendance/attRequest.vue";
import attCalendar from "@/pages/attendance/attCalendar.vue";
import attList from "@/pages/attendance/attList.vue";
import attStatus from "@/pages/attendance/attStatus.vue";
import attTransfer from "@/pages/attendance/attTransfer.vue";

import {PathName} from "@/constant/routeData";

export default [
  // 请假
  {
    path: '/attRequest',
    name: PathName.AttRequest,
    component: attRequest,
  },
  // 日历
  {
    path: '/attCalendar',
    name: PathName.AttCalendar,
    component: attCalendar,
  },
  {
    path: '/attList',
    name: PathName.AttList,
    component: attList,
  },
  // 请假明细
  {
    path: '/attStatus',
    name: PathName.AttStatus,
    component: attStatus,
  },
  // 请假转换
  {
    path: '/attTransfer',
    name: PathName.AttTrans,
    component: attTransfer,
  }
]
